import { render } from "./ProductBulkImportModal.vue?vue&type=template&id=6e896fa2&scoped=true"
import script from "./ProductBulkImportModal.vue?vue&type=script&lang=js"
export * from "./ProductBulkImportModal.vue?vue&type=script&lang=js"

import "./ProductBulkImportModal.vue?vue&type=style&index=0&id=6e896fa2&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e896fa2"]])

export default __exports__